var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({height: _vm.winHeight + 'px'})},[(_vm.hasPermission)?_c('div',{staticClass:"iframe-container"},[_c('iframe',{attrs:{"src":"https://api.myonewow.com/ziomyun/ptprank.php"}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }